var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 123,
    viewBox: "0 0 125 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_7826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.32 122.14C94.91 122.14 122.14 94.91 122.14 61.32C122.14 27.73 94.91 0.5 61.32 0.5C27.73 0.5 0.5 27.73 0.5 61.32C0.5 94.91 27.73 122.14 61.32 122.14Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3202 107.9C87.0457 107.9 107.9 87.0454 107.9 61.32C107.9 35.5946 87.0457 14.74 61.3202 14.74C35.5948 14.74 14.7402 35.5946 14.7402 61.32C14.7402 87.0454 35.5948 107.9 61.3202 107.9Z",
    fill: "#07F096",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4903 85.93C59.2605 85.9449 59.03 85.9449 58.8003 85.93C57.7083 85.8222 56.657 85.4593 55.7311 84.8704C54.8053 84.2815 54.0308 83.4833 53.4703 82.54L34.2003 50.06C33.2537 48.4633 32.9801 46.5561 33.4395 44.7577C33.899 42.9593 35.0539 41.417 36.6503 40.47C38.2469 39.5235 40.1542 39.2498 41.9526 39.7092C43.751 40.1687 45.2932 41.3236 46.2403 42.92L60.6603 67.16L112.09 9.84999C113.331 8.47043 115.068 7.63971 116.921 7.54033C118.773 7.44096 120.589 8.08105 121.97 9.32C123.351 10.559 124.184 12.2957 124.285 14.1482C124.386 16.0008 123.748 17.8178 122.51 19.2L64.6603 83.6C64.0087 84.3275 63.2122 84.9107 62.3218 85.312C61.4314 85.7132 60.4669 85.9238 59.4903 85.93Z",
    fill: "#003E4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_7826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.29,
    height: 122.64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.63b5bc90c5908100ef9d5480fef92ca1.svg";
export { ForwardRef as ReactComponent };